import { render, staticRenderFns } from "./SalaryTaxSlab.vue?vue&type=template&id=868481e8&"
import script from "./SalaryTaxSlab.vue?vue&type=script&lang=js&"
export * from "./SalaryTaxSlab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports